import { gql, useQuery } from '@apollo/client';
import useStoreAndLanguageParams from '../../core/hooks/useStoreAndLanguageParams';
import type { PostStory } from '../../content/types/types';
import Storyblok from '../../content/storyblok/storyblok';
import useContentClient from '../../content/hooks/useContentClient';
import getPublishedDate from '../utils/getPublishedDate';
import { STORYBLOK_ERROR_MESSAGE } from '../../content/constants';

const postQuery = gql`
    query postQuery(
        $by_slugs: String
        $first_published_at_lt: String
        $starts_with: String
    ) {
        PostItems(
            by_slugs: $by_slugs
            first_published_at_lt: $first_published_at_lt
            starts_with: $starts_with
        ) {
            items {
                content {
                    attachments
                    body
                    component
                    date
                    featured_image {
                        alt
                        filename
                        focus
                        title
                    }
                    summary
                    title
                    meta_fields
                }
                name
                id
                lang
                first_published_at
            }
        }
    }
`;

const usePostPage = (page: string) => {
    const { store, language } = useStoreAndLanguageParams();
    const client = useContentClient();

    const { data, loading, error } = useQuery<{
        PostItems: {
            items: PostStory[];
            total: number;
        };
    }>(postQuery, {
        variables: {
            starts_with: Storyblok.formatSlug(store, language, ''),
            by_slugs: `*/${page}`,
            first_published_at_lt: Storyblok.status.isPreview
                ? undefined
                : getPublishedDate(),
        },
        client,
    });

    if (error) {
        throw new Error(STORYBLOK_ERROR_MESSAGE, { cause: error });
    }

    return {
        data: data?.PostItems.items[0],
        loading,
    };
};

export default usePostPage;
